import uiSlice from 'store/modules/ui';
import { createSnack } from 'common/utils/general';
import humanizeError from 'common/utils/humanizeError';

const error =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const result = next(action);
    const { type, payload } = action;

    // If request fail, show error alert
    if (type.indexOf('Error') >= 0) {
      const key = type.toLowerCase().replace(/\//gi, '');
      const raw = typeof payload === 'object' && payload !== null ? payload.message : payload;
      // Nunca mostrar mensajes técnicos (SQL, excepciones...) al usuario: se humanizan.
      const snack = createSnack({ key, variant: 'error', message: humanizeError(raw) });

      dispatch(uiSlice.actions.enqueueSnackbar(snack));

      return result;
    }

    return result;
  };

export default error;
